export const GET_UAH_USD_RATE_REQUEST = "GET_UAH_USD_RATE_REQUEST";
export const GET_UAH_USD_RATE_SUCCESS = "GET_UAH_USD_RATE_SUCCESS";
export const GET_UAH_USD_RATE_FAILURE = "GET_UAH_USD_RATE_FAILURE";

//predicted
export const GET_PREDICTED_UAH_USD_RATE_REQUEST = "GET_PREDICTED_UAH_USD_RATE_REQUEST";
export const GET_PREDICTED_UAH_USD_RATE_SUCCESS = "GET_PREDICTED_UAH_USD_RATE_SUCCESS";
export const GET_PREDICTED_UAH_USD_RATE_FAILURE = "GET_PREDICTED_UAH_USD_RATE_FAILURE";

//PREDICTION_METHODS
export const GET_PREDICTION_METHODS_REQUEST = "GET_PREDICTION_METHODS_REQUEST";
export const GET_PREDICTION_METHODS_SUCCESS = "GET_PPREDICTION_METHODS_SUCCESS";
export const GET_PREDICTION_METHODS_FAILURE = "GET_PREDICTION_METHODS_FAILURE";

//FINDAY
export const GET_FINDAY_REQUEST = "GET_FINDAY_REQUEST";
export const GET_FINDAY_SUCCESS = "GET_FINDAY_SUCCESS";
export const GET_FINDAY_FAILURE = "GET_FINDAY_FAILURE";

//FINDAY_RANGE
export const GET_FINDAY_RANGE_REQUEST = "GET_FINDAY_RANGE_REQUEST";
export const GET_FINDAY_RANGE_SUCCESS = "GET_FINDAY_RANGE_SUCCESS";
export const GET_FINDAY_RANGE_FAILURE = "GET_FINDAY_RANGE_FAILURE";

//ORGANIZATIONS
export const GET_ALL_ORGANIZATIONS_REQUEST = "GET_ALL_ORGANIZATIONS_REQUEST";
export const GET_ALL_ORGANIZATIONS_SUCCESS = "GET_ALL_ORGANIZATIONS_SUCCESS";
export const GET_ALL_ORGANIZATIONS_FAILURE = "GET_ALL_ORGANIZATIONS_FAILURE";

//ORGANIZATION
export const GET_ORGANIZATION_REQUEST = "GET_ORGANIZATION_REQUEST";
export const GET_ORGANIZATION_SUCCESS = "GET_ORGANIZATION_SUCCESS";
export const GET_ORGANIZATION_FAILURE = "GET_ORGANIZATION_FAILURE";

//COUNTRIES
export const GET_COUNTRIES_REQUEST = "GET_COUNTRIES_REQUEST";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILURE = "GET_COUNTRIES_FAILURE";

//REGIONS (for Catalog region filter)
export const GET_REGIONS_REQUEST = "GET_REGIONS_REQUEST";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAILURE = "GET_REGIONS_FAILURE";

//COUNTRY-Short-Fin-Info
export const GET_COUNTRY_FIN_INFO_REQUEST = "GET_COUNTRY_FIN_INFO_REQUEST";
export const GET_COUNTRY_FIN_INFO_SUCCESS = "GET_COUNTRY_FIN_INFO_SUCCESS";
export const GET_COUNTRY_FIN_INFO_FAILURE = "GET_COUNTRY_FIN_INFO_FAILURE";

//ECONOMIC Unions
export const GET_ECONOMIC_UNIONS_REQUEST = "GET_ECONOMIC_UNIONS_REQUEST";
export const GET_ECONOMIC_UNIONS_SUCCESS = "GET_ECONOMIC_UNIONS_SUCCESS";
export const GET_ECONOMIC_UNIONS_FAILURE = "GET_ECONOMIC_UNIONS_FAILURE";

//ECONOMIC-Short-Fin-Info
export const GET_ECONOMIC_UNION_FIN_INFO_REQUEST = "GET_ECONOMIC_UNION_FIN_INFO_REQUEST";
export const GET_ECONOMIC_UNION_FIN_INFO_SUCCESS = "GET_ECONOMIC_UNION_FIN_INFO_SUCCESS";
export const GET_ECONOMIC_UNION_FIN_INFO_FAILURE = "GET_ECONOMIC_UNION_FIN_INFO_FAILURE";

//Actual-GDP
export const GET_ACTUAL_GDP_REQUEST = "GET_ACTUAL_GDP_REQUEST";
export const GET_ACTUAL_GDP_SUCCESS = "GET_ACTUAL_GDP_SUCCESS";
export const GET_ACTUAL_GDP_FAILURE = "GET_ACTUAL_GDP_FAILURE";

//Actual-YEAR-inflation
export const GET_ACTUAL_YEAR_INFLACTION_REQUEST = "GET_ACTUAL_YEAR_INFLACTION_REQUEST";
export const GET_ACTUAL_YEAR_INFLACTION_SUCCESS = "GET_ACTUAL_YEAR_INFLACTION_SUCCESS";
export const GET_ACTUAL_YEAR_INFLACTION_FAILURE = "GET_ACTUAL_YEAR_INFLACTION_FAILURE";

//Actual-GDP_PPP
export const GET_ACTUAL_GDP_PPP_REQUEST = "GET_ACTUAL_GDP_PPP_REQUEST";
export const GET_ACTUAL_GDP_PPP_SUCCESS = "GET_ACTUAL_GDP_PPP_SUCCESS";
export const GET_ACTUAL_GDP_PPP_FAILURE = "GET_ACTUAL_GDP_PPP_FAILURE";


//COUNTRY-Full-Fin-Info
export const GET_COUNTRY_FULL_INFO_REQUEST = "GET_COUNTRY_FULL_INFO_REQUEST";
export const GET_COUNTRY_FULL_INFO_SUCCESS = "GET_COUNTRY_FULL_INFO_SUCCESS";
export const GET_COUNTRY_FULL_INFO_FAILURE = "GET_COUNTRY_FULL_INFO_FAILURE";

//COUNTRY-HIGHLIGHTS
export const GET_COUNTRY_HIGHLIGHTS_REQUEST = "GET_COUNTRY_HIGHLIGHTS_REQUEST";
export const GET_COUNTRY_HIGHLIGHTS_SUCCESS = "GET_COUNTRY_HIGHLIGHTS_SUCCESS";
export const GET_COUNTRY_HIGHLIGHTS_FAILURE = "GET_COUNTRY_HIGHLIGHTS_FAILURE";

//COUNTRY-COMPARISON
export const GET_COUNTRY_COMPARISON_REQUEST = "GET_COUNTRY_COMPARISON_REQUEST";
export const GET_COUNTRY_COMPARISON_SUCCESS = "GET_COUNTRY_COMPARISON_SUCCESS";
export const GET_COUNTRY_COMPARISON_FAILURE = "GET_COUNTRY_COMPARISON_FAILURE";

//COUNTRY-FORECAST
export const GET_COUNTRY_FORECAST_REQUEST = "GET_COUNTRY_FORECAST_REQUEST";
export const GET_COUNTRY_FORECAST_SUCCESS = "GET_COUNTRY_FORECAST_SUCCESS";
export const GET_COUNTRY_FORECAST_FAILURE = "GET_COUNTRY_FORECAST_FAILURE";

//FORECAST-ACCURACY
export const GET_FORECAST_ACCURACY_REQUEST = "GET_FORECAST_ACCURACY_REQUEST";
export const GET_FORECAST_ACCURACY_SUCCESS = "GET_FORECAST_ACCURACY_SUCCESS";
export const GET_FORECAST_ACCURACY_FAILURE = "GET_FORECAST_ACCURACY_FAILURE";

//DATA-SYNC
export const GET_DATA_SYNC_STATUS_REQUEST = "GET_DATA_SYNC_STATUS_REQUEST";
export const GET_DATA_SYNC_STATUS_SUCCESS = "GET_DATA_SYNC_STATUS_SUCCESS";
export const GET_DATA_SYNC_STATUS_FAILURE = "GET_DATA_SYNC_STATUS_FAILURE";


//RegionalData

//Regional-Inflation
export const GET_REGIONAL_INFLATION_REQUEST = "GET_REGIONAL_INFLATION_REQUEST";
export const GET_REGIONAL_INFLATION_SUCCESS = "GET_REGIONAL_INFLATION_SUCCESS";
export const GET_REGIONAL_INFLATION_FAILURE = "GET_REGIONAL_INFLATION_FAILURE";

//Regional-Gdp
 export const GET_REGIONAL_GDP_REQUEST = "GET_REGIONAL_GDP_REQUEST";
 export const GET_REGIONAL_GDP_SUCCESS = "GET_REGIONAL_GDP_SUCCESS";
 export const GET_REGIONAL_GDP_FAILURE = "GET_REGIONAL_GDP_FAILURE";

// MACRO-PULSE
export const GET_MACRO_PULSE_REQUEST = "GET_MACRO_PULSE_REQUEST";
export const GET_MACRO_PULSE_SUCCESS = "GET_MACRO_PULSE_SUCCESS";
export const GET_MACRO_PULSE_FAILURE = "GET_MACRO_PULSE_FAILURE";

export const GET_MACRO_CALENDAR_REQUEST = "GET_MACRO_CALENDAR_REQUEST";
export const GET_MACRO_CALENDAR_SUCCESS = "GET_MACRO_CALENDAR_SUCCESS";
export const GET_MACRO_CALENDAR_FAILURE = "GET_MACRO_CALENDAR_FAILURE";

// Macro briefing (F21)
export const GET_MACRO_BRIEFING_REQUEST = "GET_MACRO_BRIEFING_REQUEST";
export const GET_MACRO_BRIEFING_SUCCESS = "GET_MACRO_BRIEFING_SUCCESS";
export const GET_MACRO_BRIEFING_FAILURE = "GET_MACRO_BRIEFING_FAILURE";

// Historical GDP
export const GET_HISTORICAL_GDP_REQUEST = "GET_HISTORICAL_GDP_REQUEST";
export const GET_HISTORICAL_GDP_SUCCESS = "GET_HISTORICAL_GDP_SUCCESS";
export const GET_HISTORICAL_GDP_FAILURE = "GET_HISTORICAL_GDP_FAILURE";

// Historical Inflation
export const GET_HISTORICAL_INFLATION_REQUEST = "GET_HISTORICAL_INFLATION_REQUEST";
export const GET_HISTORICAL_INFLATION_SUCCESS = "GET_HISTORICAL_INFLATION_SUCCESS";
export const GET_HISTORICAL_INFLATION_FAILURE = "GET_HISTORICAL_INFLATION_FAILURE";

// Historical Policy Rate
export const GET_HISTORICAL_POLICY_RATE_REQUEST = "GET_HISTORICAL_POLICY_RATE_REQUEST";
export const GET_HISTORICAL_POLICY_RATE_SUCCESS = "GET_HISTORICAL_POLICY_RATE_SUCCESS";
export const GET_HISTORICAL_POLICY_RATE_FAILURE = "GET_HISTORICAL_POLICY_RATE_FAILURE";

// Actual Policy Rate
export const GET_ACTUAL_POLICY_RATE_REQUEST = "GET_ACTUAL_POLICY_RATE_REQUEST";
export const GET_ACTUAL_POLICY_RATE_SUCCESS = "GET_ACTUAL_POLICY_RATE_SUCCESS";
export const GET_ACTUAL_POLICY_RATE_FAILURE = "GET_ACTUAL_POLICY_RATE_FAILURE";

// Studio
export const GET_STUDIO_INDICATORS_REQUEST = "GET_STUDIO_INDICATORS_REQUEST";
export const GET_STUDIO_INDICATORS_SUCCESS = "GET_STUDIO_INDICATORS_SUCCESS";
export const GET_STUDIO_INDICATORS_FAILURE = "GET_STUDIO_INDICATORS_FAILURE";